import { render, staticRenderFns } from "./media-gallery.vue?vue&type=template&id=578b452c"
import script from "./media-gallery.vue?vue&type=script&lang=js"
export * from "./media-gallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports